import React from 'react';
import styled from 'styled-components';
import {
  radii,
  fonts,
  serviceCategoryColors,
  getServiceCategory,
} from '../designSystem';

const Pill = styled.span`
  display: inline-flex;
  align-items: center;
  padding: 4px 12px;
  border-radius: ${radii.pill};
  font-family: ${fonts.body};
  font-size: 0.75rem;
  font-weight: 500;
  white-space: nowrap;
  background-color: ${(p) => p.$bg};
  color: ${(p) => p.$color};
`;

export default function ServicePill({ name, category }) {
  const cat = category || getServiceCategory(name);
  const style = serviceCategoryColors[cat] || serviceCategoryColors.extra;

  return (
    <Pill $bg={style.bg} $color={style.text}>
      {name}
    </Pill>
  );
}
